/* Profile Context Actions */
export enum ProfileActionTypes {
  UpdateProfile = 'UpdateProfile',
  UpdateProfileWallet = 'UpdateProfileWallet',
  UpdateProfileWalletAccountsDetails = 'UpdateProfileWalletAccountsDetails',
  ClearProfile = 'ClearProfile',
}
